var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticStyle:{"width":"15px","height":"15px"},attrs:{"fab":"","color":_vm.$pingModule.color()}}),_vm._v(" "+_vm._s(_vm.$pingModule.getPing() + "ms")+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }